import { mutatorAction } from 'satcheljs';
import { store } from '../store/store';

export const setCustomPalette = mutatorAction(
    'setCustomPalette',
    (customPalette?: Record<string, string>) => {
        store.customPalette = customPalette;
    }
);
